module.exports = __webpack_public_path__ + "static/media/2021_2A3A0774.f6d1d134.jpg";